import { Group, Stack } from '@mantine/core';
import {
	DataQualityClassification,
	DataQualityClassificationBounds,
} from '@repo/common/enums/dataQualityClassification';
import { Text, Title } from '@repo/foundations';
import { DataQualityBadge } from '../DataQualityBadge';

const GREAT_RANGE = `${DataQualityClassificationBounds.GREAT} - 100%`;
const GOOD_RANGE = `${DataQualityClassificationBounds.GOOD} - ${DataQualityClassificationBounds.GREAT - 1}%`;
const MODERATE_RANGE = `${DataQualityClassificationBounds.MODERATE} - ${DataQualityClassificationBounds.GOOD - 1}%`;
const POOR_RANGE = `0 - ${DataQualityClassificationBounds.MODERATE - 1}%`;

export function DataQualityBenchmarkTooltip() {
	return (
		<Stack spacing="sm" p="sm" w={240}>
			<Title size="sm">Quality benchmark</Title>
			<Stack spacing="xs">
				<Group position="apart" spacing={0}>
					<DataQualityBadge classification={DataQualityClassification.GREAT} />
					<Text size="sm">{GREAT_RANGE}</Text>
				</Group>
				<Group position="apart" spacing={0}>
					<DataQualityBadge classification={DataQualityClassification.GOOD} />
					<Text size="sm">{GOOD_RANGE}</Text>
				</Group>
				<Group position="apart" spacing={0}>
					<DataQualityBadge
						classification={DataQualityClassification.MODERATE}
					/>
					<Text size="sm">{MODERATE_RANGE}</Text>
				</Group>
				<Group position="apart" spacing={0}>
					<DataQualityBadge classification={DataQualityClassification.POOR} />
					<Text size="sm">{POOR_RANGE}</Text>
				</Group>
			</Stack>
			<Text size="xs" color="text/secondary/default">
				Reflects the accuracy, reliability, stewardship, and usability of this
				resource, helping you assess its overall quality.
			</Text>
		</Stack>
	);
}
